export function normalizeUnicodeNfkc(value: string): string;
export function normalizeUnicodeNfkc<T>(value: T): T;
export function normalizeUnicodeNfkc(value: unknown) {
  if (typeof value !== 'string') {
    return value;
  }

  const normalized =
    typeof value.normalize === 'function' ? value.normalize('NFKC') : value;

  // Prefer Unicode property escapes when available (ES2018+):
  // - https://tc39.es/ecma262/#sec-pattern-semantics
  // If unsupported, fall back to stripping common format characters.
  try {
    return normalized.replace(new RegExp('\\p{Cf}', 'gu'), '');
  } catch {
    return normalized.replace(
      / [\u200B-\u200F\u202A-\u202E\u2060-\u206F\uFEFF]/g,
      ''
    );
  }
}
